import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Swords } from 'lucide-react';
import { WorldSection } from './WorldPageHeader';
import { itemSourceMap } from '../../data/guide/entries';
import { entryPathById, getEntry } from '../../utils/guideIndex';
import { JEWEL_MAIN_SOURCE, JEWEL_RARE_NOTE, STAFF_JEWEL_DATE, staffJewelSources } from '../../data/guide/jewelSources';

/** "Dónde conseguirlo" de Bless, Life, Soul y Chaos: solo invasiones + aviso de cofres y drop muy bajo. */
export function StaffJewelSources({
  id
}: {
  id: string;
}) {
  const jewel = staffJewelSources[id];
  const links = (itemSourceMap[jewel.entryId] ?? []).filter((l, i, all) => all.findIndex(x => x.entryId === l.entryId) === i);
  return <WorldSection id="donde-conseguirlo" title="Dónde conseguirlo" count={links.length} data-id="element-2251" data-mp="1qel77dewd4cg">
      <p className="text-gray-200" data-id="element-2252" data-mp="36sbgcykviisy">{JEWEL_MAIN_SOURCE}</p>
      {links.length > 0 && <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-2253" data-mp="31ti1b1pxujqo">
          {links.map(l => <li key={l.entryId} data-id="element-2254" data-mp="1t683hs5q8l0f">
              <Link to={entryPathById(l.entryId, l.sectionId)} className="flex h-full items-center gap-3 rounded-2xl border border-white/10 bg-[#0A1628] p-3.5 transition-colors duration-150 hover:border-[#D4AF37]/40" data-id="element-2255" data-mp="1t4wyxq4gj989">
                <Swords className="h-5 w-5 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-2256" data-mp="275hiwpm3zb3c" />
                <span className="min-w-0 flex-1" data-id="element-2257" data-mp="1afgxn0ky7cqs">
                  <span className="block font-semibold text-white" data-id="element-2258" data-mp="1ags08x2nqegb">{getEntry(l.entryId)?.title ?? l.entryId}</span>
                  {l.chance && <span className="block text-xs text-gray-400" data-id="element-2259" data-mp="1jfn7mchftul7">{l.chance} por monstruo</span>}
                </span>
                <ChevronRight className="h-4 w-4 shrink-0 text-gray-500" aria-hidden="true" data-id="element-2260" data-mp="1o6vhf9mojhyw" />
              </Link>
            </li>)}
        </ul>}
      <p className="mt-3 text-sm text-gray-300" data-id="element-2261" data-mp="rmd2tbvzutul">{JEWEL_RARE_NOTE}</p>
      <p className="mt-2 text-xs text-gray-500" data-id="element-2262" data-mp="voq67tn9qfo7">Confirmado por administración · {STAFF_JEWEL_DATE}</p>
    </WorldSection>;
}